import ReactQuill from "react-quill";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import copydark from "../../assets/copy.svg";
import transcript from '../../assets/transcript.png';
import { useEffect, useRef, useState } from "react";

const TranscriptModal = ({ popup, text,audioSrc,setAudioSrc, setmodal, handleEditTranscript, handlealertClick }) => {
  const [editedText, setEditedText] = useState(text);
  const [isEditing, setIsEditing] = useState(false);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isMuted, setIsMuted] = useState(false);
  const copytext = () => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = editedText;
    const plainText = tempElement.innerText;

    navigator.clipboard.writeText(plainText)
      .then(() => handlealertClick("Copied", "success"))
      .catch((err) => {
        console.error("Failed to copy text: ", err);
        handlealertClick("Failed to copy", "error");
      });
  };
  const togglePlayback = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (audio.paused) {
      audio.play();
      setIsPlaying(true);
    } else {
      audio.pause();
      setIsPlaying(false);
    }
  };

  const handleSpeedChange = (e) => {
    const speed = parseFloat(e.target.value);
    if (audioRef.current) {
      audioRef.current.playbackRate = speed;
      setPlaybackRate(speed);
    }
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
    }
  };

  const handleSeek = (e) => {
    const time = parseFloat(e.target.value);
    if (audioRef.current) {
      audioRef.current.currentTime = time;
      setCurrentTime(time);
    }
  };

  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !audioRef.current.muted;
      setIsMuted(audioRef.current.muted);
    }
  };

  const formatText = (text) => {
    // Remove all HTML tags
    const cleanText = text.replace(/<\/?[^>]+(>|$)/g, '');
  
    return cleanText
      .replace(/\s*(Doctor:|Patient:|Other:)/g, '\n$1')
      .split(/\n+/)
      .filter(Boolean)
      .map((line, index) => {
        const isDoctor = line.startsWith('Doctor:');
        const isPatient = line.startsWith('Patient:');
        const isOther = line.startsWith('Other:');
        const role = isDoctor ? 'Doctor' : isPatient ? 'Patient' : 'Other';
        const message = line.replace(/^(Doctor:|Patient:|Other:)/, '').trim();
  
        return (
          <div
            className="text-start"
            key={index}
            style={{
              display: 'flex',
              justifyContent: isDoctor ? 'flex-start' : isPatient ? 'flex-start' : 'start',
              marginBottom: '12px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span
                className="text-sm"
                style={{
                  borderRadius: '9999px',
                  border: isDoctor
                    ? '1px solid #BFDBFE'
                    : isPatient
                    ? '1px solid #FDE68A'
                    : '1px solid #E5E7EB',
                  background: isDoctor
                    ? '#DBEAFE'
                    : isPatient
                    ? '#FEF3C7'
                    : '#F3F4F6',
                  padding: '4px 12px',
                  fontWeight: 500,
                  color: isDoctor
                    ? '#1D4ED8'
                    : isPatient
                    ? '#B45309'
                    : '#6B7280',
                  minWidth: '80px',
                  textAlign: 'center',
                }}
              >
                {role}
              </span>
              <span className='text-sm' style={{ color: '#000' }}>{message}</span>
            </div>
          </div>
        );
      });
  };
  
  

  if (!popup) return null;

  const lineCount = (editedText.match(/Doctor[:]*|Patient[:]*/g) || []).length;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => setmodal(false)}></div>

      <div className="flex flex-col sm:ml-8 h-full shadow-[0px_2px_13px_#00000040] p-4 gap-2 w-full max-w-[550px] sm:max-w-[60%] sm:min-h-[400px] sm:h-[80vh] sm:max-h-[90vh] bg-white fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" style={{ borderRadius: "8px", background: "white", overflow: "hidden" }}>
      <div className="flex items-center flex-wrap justify-center sm:justify-between w-full mb-4 gap-4">
  {/* Left Section: Transcript label, Edit button */}
  <div className="flex items-center gap-4  flex-shrink-0">
    <div className="text-xl font-medium">Transcript</div>
    <div
      onClick={() => setIsEditing(true)}
      className="border-2 border-[#E4E4E7] p-1 rounded cursor-pointer hover:bg-gray-100 transition"
    >
      <img src={transcript} alt="Edit" className="w-5 h-5" />
    </div>
  </div>

  {/* Audio Player */}
  {audioSrc && (
    <div className="flex flex-col gap-2 max-w-[300px] w-full bg-gray-100 px-2 py-2 rounded-md shadow-sm border border-gray-300">
      <div className="flex justify-between items-center text-xs text-gray-700">
        <div className="flex items-center gap-1">
          <label htmlFor="speed" className="text-gray-600 text-xs">Speed:</label>
          <select
            id="speed"
            value={playbackRate}
            onChange={handleSpeedChange}
            className="border rounded px-1 py-0.5 text-xs"
          >
            <option value="0.5">0.5x</option>
            <option value="1">1x</option>
            <option value="1.5">1.5x</option>
            <option value="2">2x</option>
          </select>
        </div>
        <button
          onClick={togglePlayback}
          className="px-1.5 py-0.5 bg-blue-600 text-white text-[10px] rounded hover:bg-blue-700"
        >
          {isPlaying ? "Pause" : "Play"}
        </button>
        <button
          onClick={toggleMute}
          className="px-1.5 py-0.5 bg-yellow-500 text-white text-[10px] rounded hover:bg-yellow-600"
        >
          {isMuted ? "Unmute" : "Mute"}
        </button>
        <a
          href={audioSrc}
          download
          className="px-1.5 py-0.5 bg-green-600 text-white text-[10px] rounded hover:bg-green-700"
        >
          Download
        </a>
      </div>
      <audio
        ref={audioRef}
        src={audioSrc}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={() => setIsPlaying(false)}
        className="hidden"
      />
      <div className="flex items-center text-gray-600 text-xs gap-1">
        <span>{Math.floor(currentTime)}s</span>
        <input
          type="range"
          min="0"
          max={duration}
          value={currentTime}
          onChange={handleSeek}
          className="w-full accent-blue-500 h-1"
        />
        <span>{Math.floor(duration)}s</span>
      </div>
    </div>
  )}

  {/* Right Section: Close Icon */}
  <div className="flex-shrink-0">
    <CloseIcon
      style={{ cursor: 'pointer', color: '#000' }}
      onClick={() => {
        setAudioSrc('');
        setmodal(false);
      }}
    />
  </div>
</div>



        {/* Toggle between view and edit mode */}
        <div className="h-full flex-grow overflow-hidden">
          {isEditing ? (
            <ReactQuill
              className="w-full text-start flex-grow custom-scrollbar p-2 font-inter"
              style={{
                borderRadius: "8px",
                border: "1px solid #A2C6FD",
                background: "#FFF",
                boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
                minHeight: "200px",
                height: "100%",
                overflow: "hidden",
              }}
              value={editedText}
              onChange={(value) => setEditedText(value)}
              placeholder={""}
            />
          ) : (
            <div className="overflow-auto max-h-full text-start">
              {formatText(editedText)}
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="w-full flex justify-between items-center gap-4 mt-4">
          <div>Transcript lines: {lineCount}</div>
          <div className="flex gap-4">
            <button className="flex items-center gap-2 px-3 py-1 bg-[#FFF] border-2 border-[#E4E4E7] text-black rounded-md" onClick={copytext}>
              <img src={copydark} alt="Copy" className="w-4 h-4" /> Copy
            </button>
            {isEditing && (
              <button className="flex items-center gap-2 px-3 py-1 bg-[#FFF] border-2 border-[#E4E4E7] text-[#000000] rounded-md" onClick={() => { handleEditTranscript(editedText); setIsEditing(false); }}>
                <SaveIcon className="text-[#000000]" /> Save
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TranscriptModal;